export const LOCAL_STORAGE_TOKEN_KEY = 'itsHereScannerToken'
